import { autoCapitalize } from '@/utils/autoCapitalize'
import { formatCPF } from '@/utils/formatCPF/formatCPF'
import { phoneReplace } from '@/utils/formatPhone'

const handleStatus = (status: string) => {
  if (status === 'PENDENTE_ATIVACAO') {
    return 'Pendente'
  } else {
    return autoCapitalize(status)
  }
}

class PatientListMapper {
  toDomain(persistenceData) {
    return {
      patientId: persistenceData?.idPaciente?.toString(),
      userId: persistenceData?.idUsuario || '-',
      clinicId: persistenceData?.idClinica?.toString() || '-',
      patientName: autoCapitalize(persistenceData?.nome) || '-',
      patientSocialName: persistenceData?.nomeSocial || '',
      patientEmail: persistenceData?.email || '-',
      patientPhone: phoneReplace(persistenceData?.telefoneCel) || '-',
      rawPatientPhone: persistenceData?.telefoneCel || '-',
      birthday: persistenceData?.dataNascimento || '-',
      cpf: formatCPF(persistenceData?.cpf) || '-',
      rawCpf: persistenceData?.cpf || '-',
      clinic: autoCapitalize(persistenceData?.nomeClinica) || '-',
      ownership: autoCapitalize(persistenceData?.titularidade) || '-',
      status: handleStatus(persistenceData?.statusPaciente) || '-',
      enableScreening: persistenceData?.flagHabilitaTriagem,
      situation: autoCapitalize(persistenceData?.statusUsuario) || '-',
      walletAgreement: persistenceData?.carteiraConvenio,
      itFound: persistenceData?.encontrou,
      registration: persistenceData?.matricula,
    }
  }
}

export default new PatientListMapper()
